import React from 'react';
import { CRQ_STATUS_DISPLAY_NAMES } from 'AppSrc/core/crq/crq-statuses';
import { getDateDisplay } from 'AppSrc/core/crq/crq-table-utils';
import PropTypes from 'prop-types';
import { CrossSvg } from 'AppSrc/core/components/common/svg-icons';
import { SLA_FILTER_OPTIONS } from './crq-list-sla-filter';
import { SR_FILTER_OPTIONS } from './crq-list-circuit-check-filter';
import { MyCRQFilterDisplayName } from './crq-list-mycrq-filter';
import { FlightChangesFilterDisplayName } from './crq-list-flightchanges-filter';

const CrqListFilterTag = ({
  onClear,
  text,
}) => (
  <div className="crq-list-filter-tag">
    <button
      type="button"
      onClick={onClear}
    >
      <CrossSvg />
    </button>
    <span>{text}</span>
  </div>
);

CrqListFilterTag.propTypes = {
  onClear: PropTypes.func,
  text: PropTypes.string,
};

const CrqListFilterTags = ({
  selectedStatuses,
  selectedSlas,
  selectedDate,
  selectedEndDate,
  selectedRaisedDate,
  selectedMyCRQ,
  selectedFlight,
  clearDate,
  clearEndDate,
  clearRaisedDate,
  clearStatus,
  clearSla,
  selectedReason,
  clearSelectedReason,
  clearMyCRQ,
  clearFlight,
}) => (

  <div className="crq-list-filter-tags">
    <ul>
      {selectedSlas && selectedSlas.map((sla) => {
        const slaOption = SLA_FILTER_OPTIONS.find((option) => option.id === sla);
        if (!slaOption) {
          console.warn('sla filter options not found with id', sla);
          return null;
        }
        const slaName = slaOption.text;
        return (
          <li key={sla}>
            <CrqListFilterTag
              text={slaName}
              onClear={() => clearSla(sla)}
            />
          </li>
        );
      })}
      {selectedReason && selectedReason.map((reason) => {
        const statusReasonoption = SR_FILTER_OPTIONS.find((option) => option.id === reason);
        const reasonName = statusReasonoption.text;
        return (
          <li key={reason}>
            <CrqListFilterTag
              text={reasonName}
              onClear={() => clearSelectedReason(reason)}
            />
          </li>
        );
      })}

      {selectedStatuses && selectedStatuses.map((status) => {
        const statusName = CRQ_STATUS_DISPLAY_NAMES[status];
        return (
          <li key={status}>
            <CrqListFilterTag
              text={statusName}
              onClear={() => clearStatus(status)}
            />
          </li>
        );
      })}
      {selectedDate && (
        <li>
          <CrqListFilterTag
            text={getDateDisplay(selectedDate)}
            onClear={clearDate}
          />
        </li>
      )}
      {selectedEndDate && (
        <li>
          <CrqListFilterTag
            text={getDateDisplay(selectedEndDate)}
            onClear={clearEndDate}
          />
        </li>
      )}
      {selectedRaisedDate && (
        <li>
          <CrqListFilterTag
            text={getDateDisplay(selectedRaisedDate)}
            onClear={clearRaisedDate}
          />
        </li>
      )}
      {selectedMyCRQ && (
        <li>
          <CrqListFilterTag
            text={MyCRQFilterDisplayName}
            onClear={clearMyCRQ}
          />
        </li>
      )}
      {selectedFlight && (
        <li>
          <CrqListFilterTag
            text={FlightChangesFilterDisplayName}
            onClear={clearFlight}
          />
        </li>
      )}
    </ul>
  </div>
);

CrqListFilterTags.propTypes = {
  selectedSlas: PropTypes.arrayOf(PropTypes.string),
  selectedStatuses: PropTypes.arrayOf(PropTypes.string),
  selectedDate: PropTypes.instanceOf(Date),
  selectedEndDate: PropTypes.instanceOf(Date),
  selectedRaisedDate: PropTypes.instanceOf(Date),
  selectedMyCRQ: PropTypes.bool,
  selectedFlight: PropTypes.bool,
  clearDate: PropTypes.func,
  clearEndDate: PropTypes.func,
  clearRaisedDate: PropTypes.func,
  clearStatus: PropTypes.func,
  clearSla: PropTypes.func,
  clearMyCRQ: PropTypes.func,
  clearFlight: PropTypes.func,
  selectedReason: PropTypes.arrayOf(PropTypes.string),
  clearSelectedReason: PropTypes.func,
};

export { CrqListFilterTags };
